// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/views/partner/crud/editTournament/styles.css
// module id = 2502
// module chunks = 0